import {
    ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, OnInit, TemplateRef, ViewChild
} from '@angular/core';
import {MatExpansionModule, MatExpansionPanel, MatExpansionPanelTitle,} from '@angular/material/expansion';
import {MatButton} from '@angular/material/button';
import {AsyncPipe, JsonPipe, NgTemplateOutlet} from '@angular/common';
import {ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {IndexItemsListComponent} from '../index-items-list/index-items-list.component';
import {ReferenceService} from '../../../apiModule1';
import {UnitSelectorComponent} from '../unit-selector/unit-selector.component';
import {MatInput} from '@angular/material/input';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
    selector: 'pas-filling-method',
    standalone: true,
    imports: [MatExpansionPanel, MatExpansionPanelTitle, MatExpansionModule, MatButton, NgTemplateOutlet, IndexItemsListComponent, UnitSelectorComponent, FormsModule, MatInput, ReactiveFormsModule, AsyncPipe],
    providers: [{
        provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FillingMethodComponent), multi: true
    },],
    templateUrl: './filling-method.component.html',
    styleUrl: './filling-method.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FillingMethodComponent implements ControlValueAccessor, OnInit {
    @ViewChild('iasSport', {read: TemplateRef}) iasSportTemplate: TemplateRef<any> | null = null;
    @ViewChild('numberEnter', {read: TemplateRef}) numberEnterTemplate: TemplateRef<any> | null = null;
    @ViewChild('list', {read: TemplateRef}) listTemplate: TemplateRef<any> | null = null;

    content: TemplateRef<any> | null = null;
    currentButton: FillType = 'Number_Enter';

    emptyUnit = {
        id: 0, name: '', shortName: '',
    } as Unit;

    units: Unit[] = [];

    indexItems = new BehaviorSubject<Unit[]>([]);
    searchIndexInWithoutRemarks = new FormControl('')
    filteredSearchIndexInWithoutRemarks$: Observable<Unit[] | undefined> = combineLatest([
        this.searchIndexInWithoutRemarks.valueChanges.pipe(startWith('')),
        this.indexItems
    ]).pipe(
        map(([searchTerm, items]) => {
            if (!searchTerm) return items;
            return items?.filter(i =>
                i.name.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()) ||
                i.shortName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())
            );
        })
    );

    constructor(private referenceService: ReferenceService, private cdr: ChangeDetectorRef) {
        this.referenceService.apiReferenceUnitsGet().subscribe(({values}: { values: Unit[] }) => {
            this.units = values;
            this.cdr.markForCheck();
        })
    }

    switchContent(item: TemplateRef<any>, indexButton: FillType) {
        this.content = item;
        this.currentButton = indexButton;
        this.value = {...this._value as FillingMethodValue, fillType: indexButton}
    }

    _value: FillingMethodValue | null = null;
    get value(): FillingMethodValue | null {
        return this._value;
    }

    set value(value: FillingMethodValue | null) {
        this._value = value;
        if (this._value !== null) {
            if (!('indexItems' in this._value) || !Array.isArray(this._value.indexItems)) {
                this._value.indexItems = []
                this.indexItems.next([]);
            }
        }
        if (value) {
            const mapVar: Record<FillType, TemplateRef<any> | null> = {
                'Number_Enter': this.numberEnterTemplate,
                'Ias_Sport': this.iasSportTemplate,
                'List_Select': this.listTemplate,
            }
            this.currentButton = value.fillType
            this.content = mapVar[value.fillType];
            value.indexItems?.length && this.indexItems.next(value.indexItems);
        }

        this.onChange(value);
        this.cdr.detectChanges()
    }

    // Функции, которые будут зарегистрированы Angular
    onChange: (value: FillingMethodValue | null) => void = () => {
    };
    onTouched: () => void = () => {
    };

    // Этот метод вызывается Angular для установки значения
    writeValue(value: FillingMethodValue): void {
        this.value = value;
    }

    // Этот метод вызывается Angular, чтобы зарегистрировать функцию, которую нужно вызвать при изменении значения
    registerOnChange(fn: (value: FillingMethodValue | null) => void): void {
        this.onChange = fn;
    }

    // Этот метод вызывается Angular, чтобы зарегистрировать функцию, которую нужно вызвать при взаимодействии
    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    // Этот метод позволяет Angular изменять состояние disabled компонента
    setDisabledState(isDisabled: boolean): void {
        // Здесь можно управлять состоянием disabled компонента
    }


    onUnitChange($event: Unit) {
        this.value = {...this.value, unit: $event} as FillingMethodValue;
    }

    onItemsChange($event: Unit[]) {
        this.value = {...this.value, indexItems: $event} as FillingMethodValue;
        this.indexItems.next($event)
    }

    onFillingWithoutRemarksChange($event: Event) {
        const selected = ($event.target as HTMLInputElement).value
        console.log(selected);
        const foundIndexItemIndex = this.value?.indexItems?.findIndex(e=>JSON.stringify(e).toLocaleLowerCase().includes(selected.toLocaleLowerCase()));
        console.log(foundIndexItemIndex)
        this.value?.indexItems?.forEach((item, index)=>{
            if (index === foundIndexItemIndex) {
                item.noViolations = true
            } else {
                item.noViolations = false
            }
        })
        this.value = {...this.value} as FillingMethodValue;
    }

    ngOnInit(): void {
        // this.searchIndexInWithoutRemarks.valueChanges.subscribe((value: string) => {})
    }

    protected readonly JsonPipe = JsonPipe;
    protected readonly JSON = JSON;
}
